<template>
  <div class="poll-form">
    <div v-if="!poll">
      <spinner size="3x"></spinner>
    </div>
    <div v-else class="question-answers">
      <div class="header">
        <h2 class="text-header">{{ poll.question }}</h2>
      </div>
      <div v-if="!answered">

        <b-form-group>
          <b-form-checkbox-group v-if="isMultiAnswer" size="lg" stacked
            :options="answerOptions" v-model="userMultiAnswers" class="answers">
          </b-form-checkbox-group>
          <b-form-radio-group v-else size="lg" stacked
            :options="answerOptions" v-model="userSingleAnswer" class="answers">
          </b-form-radio-group>
        </b-form-group>

        <b-button variant="outline-primary" v-if="!answered" :disabled="cannotSubmit" @click="submitAnswer">{{ $t('polls.submit') }}</b-button>
      </div>
      <div v-else-if="answered" class="feedback">
        <i class="togo-icon togo-icon-check"></i>
        <p>{{ $t('polls.thanksFeedback') }}</p>
        <p>{{ $t('polls.closeShortly') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from '@/components/togo/spinner';

const PollForm = {
  name: 'PollForm',

  data() {
    return {
      userMultiAnswers: [],
      userSingleAnswer: null
    };
  },

  components: {
    Spinner
  },

  computed: {
    poll() {
      return this.$store.state.g2wSession.polls.active;
    },

    answerOptions() {
      if (this.poll && this.poll.answers) {
        return this.poll.answers.map((text, value) => ({text, value}));
      }
      return [];
    },

    isMultiAnswer() {
      if (this.poll) {
        if (this.poll.hasOwnProperty('type')) {
          return this.poll.type === 'MULTI_CHOICE_MULTI_ANS'; // simulive
        } else if (this.poll.hasOwnProperty('isMultipleChoice')) {
          return this.poll.isMultipleChoice; // live
        }
        this.logger.error('missing isMultiChoice value', this.poll);
      }
      return false;
    },

    answered() {
      return (
        !!this.poll
        && this.$store.state.g2wSession.polls.answered.indexOf(this.poll.id) > -1
      );
    },

    cannotSubmit() {
      if (this.isMultiAnswer) {
        return this.userMultiAnswers.length === 0;
      }

      return this.userSingleAnswer === null;
    }
  },

  methods: {
    async submitAnswer() {
      this.$emit('submitAnswer');
      // selectedAnswers is an array of stringified indexes
      let selectedAnswers;
      if (this.isMultiAnswer) {
        selectedAnswers = this.userMultiAnswers.map((answer) => `${answer}`);
      } else {
        selectedAnswers = [`${this.userSingleAnswer}`];
      }

      try {
        await this.$store.dispatch('answerPoll', {
          poll: this.poll,
          selectedAnswers
        });
      } catch (error) {
        this.logger.error('submitAnswer error', { error });
      }
    }
  }
};

export default PollForm;
</script>

<style lang="sass">
  @import 'src/scss/variables.scss';

  .poll-form
    display: flex
    align-items: center
    justify-content: center
    height: 100%

    .question-answers
      height: 100%
      width: 100%
      padding-left: 5px
      overflow: auto

      .header
        display: flex
        align-items: flex-end
        border-bottom: solid 2.5px #eaecec

        .text-header
          font-size: 20px
          font-family: 'lato-bold'
          overflow: hidden
          text-overflow: ellipsis
          line-height: normal

      .answers
        height: 100%
        padding-left: 0

        >*
          height: 100%
          line-height: normal

      button
        align-self: flex-start

    .feedback
      margin-top: 60px
      text-align: center
      font-size: 20px

      .togo-icon-check
        font-size: 40px
        color: green
        margin-bottom: 20px


    @include media-breakpoint-down(sm)
      .poll-form
        button
          width: 100%

</style>
